export async function EntmotivacionalUpdate(
    entmotivResp,
      entmotivFecha,
      entmotivObs,
      tratamientoId,
      pacienteId,
    entmotivacionalId ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-entmotiv-${entmotivFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-entmotiv-${entmotivFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            entmotivResp: entmotivResp,
            metaFecha: entmotivFecha,
            entmotivObs: entmotivObs,
        }
        
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/entmotivacional/${entmotivacionalId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}